export const PaymentContainer = () => {
  return 'Раздел "Оплата" находится в разработке';
};
